module.exports = __webpack_public_path__ + "static/media/1_008.29c4811b.jpg";